export const BACKEND_URL = 'https://api.stotrasagar.com/api';
//export const BACKEND_URL = 'http://stotrasagar-env.eba-q7rh79kn.ap-south-1.elasticbeanstalk.com/api';
//export const BACKEND_URL = 'http://localhost:3000/api';
